/* =========================================================
   LUSSERA — Theme JS (vanilla, no dependencies)
   ========================================================= */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const on = (el, ev, fn, opt) => el && el.addEventListener(ev, fn, opt);
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    } catch { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Focus trap ---------- */
  function trap(container) {
    const focusable = container.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return () => {};
    const first = focusable[0], last = focusable[focusable.length - 1];
    function handle(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    container.addEventListener('keydown', handle);
    first.focus();
    return () => container.removeEventListener('keydown', handle);
  }

  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); el._untrap = trap(el); }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); if (el._untrap) el._untrap(); }

  /* ---------- Sticky / transparent header ---------- */
  const header = $('[data-header]');
  const setHeaderState = () => {
    if (!header) return;
    if (window.scrollY > 40) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };
  window.addEventListener('scroll', setHeaderState, { passive: true });
  setHeaderState();

  /* ---------- Announcement bar rotator ---------- */
  const ann = $('[data-announcement]');
  if (ann) {
    const items = $$('.announcement-bar__item', ann);
    const rotate = (parseInt(ann.dataset.rotate, 10) || 4) * 1000;
    let i = 0;
    const show = (idx) => { items.forEach((el, n) => el.classList.toggle('is-active', n === idx)); };
    if (items.length > 1) {
      let timer = setInterval(() => { i = (i + 1) % items.length; show(i); }, rotate);
      on($('[data-ann-next]', ann), 'click', () => { i = (i + 1) % items.length; show(i); clearInterval(timer); });
      on($('[data-ann-prev]', ann), 'click', () => { i = (i - 1 + items.length) % items.length; show(i); clearInterval(timer); });
    }
  }

  /* ---------- Mobile menu ---------- */
  const mobileMenu = $('[data-mobile-menu]');
  on($('[data-open-mobile-menu]'), 'click', (e) => { e.currentTarget.setAttribute('aria-expanded', 'true'); openDrawer(mobileMenu); });
  $$('[data-close-mobile-menu]').forEach(b => on(b, 'click', () => { closeDrawer(mobileMenu); $('[data-open-mobile-menu]')?.setAttribute('aria-expanded', 'false'); }));

  /* ---------- Cart drawer & AJAX cart ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartBody = $('[data-cart-body]');
  const cartCountEls = $$('[data-cart-count]');
  const cartSubtotalEls = $$('[data-cart-subtotal]');

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  function updateFreeShipping(cart) {
    const wrap = $('[data-free-shipping]');
    if (!wrap) return;
    const threshold = parseInt(wrap.dataset.threshold, 10);
    if (!threshold) return;
    const pct = Math.min(100, (cart.total_price / threshold) * 100);
    $('[data-free-bar]', wrap).style.width = pct + '%';
    const remaining = Math.max(0, threshold - cart.total_price);
    const text = remaining > 0
      ? `You are ${money(remaining)} away from complimentary shipping`
      : `Congratulations — you qualify for complimentary shipping`;
    $('[data-free-text]', wrap).textContent = text;
  }

  function renderCart(cart) {
    cartCountEls.forEach(el => el.textContent = cart.item_count);
    cartSubtotalEls.forEach(el => el.textContent = money(cart.total_price));
    updateFreeShipping(cart);

    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = `<div style="padding:40px 0;text-align:center;color:var(--color-muted)">Your bag is empty.<br><br><a href="/collections/all" class="btn btn--dark">Continue shopping</a></div>`;
      return;
    }
    cartBody.innerHTML = cart.items.map(item => `
      <div class="mini-cart-item" data-key="${item.key}">
        <a href="${item.url}"><img src="${item.image ? item.image.replace(/\.jpg|\.jpeg|\.png|\.webp/, m => '_200x' + m) : ''}" alt="${item.product_title}" loading="lazy"></a>
        <div>
          <a href="${item.url}" class="mini-cart-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="mini-cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="mini-cart-item__row">
            <div class="qty" data-qty>
              <button type="button" data-line-minus aria-label="Decrease">−</button>
              <input type="number" value="${item.quantity}" min="0" data-line-input aria-label="Quantity">
              <button type="button" data-line-plus aria-label="Increase">+</button>
            </div>
            <span>${money(item.final_line_price)}</span>
          </div>
          <button type="button" class="mini-cart-item__remove" data-line-remove>Remove</button>
        </div>
      </div>
    `).join('');
  }

  async function refreshCart() { const c = await fetchCart(); renderCart(c); return c; }

  async function updateLine(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const c = await r.json();
    renderCart(c);
    return c;
  }

  on($('[data-open-cart]'), 'click', async () => { await refreshCart(); openDrawer(cartDrawer); });
  $$('[data-close-cart]').forEach(b => on(b, 'click', () => closeDrawer(cartDrawer)));

  if (cartBody) {
    cartBody.addEventListener('click', async (e) => {
      const item = e.target.closest('[data-key]');
      if (!item) return;
      const key = item.dataset.key;
      const inp = $('[data-line-input]', item);
      if (e.target.matches('[data-line-plus]')) { inp.value = parseInt(inp.value, 10) + 1; await updateLine(key, parseInt(inp.value, 10)); }
      else if (e.target.matches('[data-line-minus]')) { inp.value = Math.max(0, parseInt(inp.value, 10) - 1); await updateLine(key, parseInt(inp.value, 10)); }
      else if (e.target.matches('[data-line-remove]')) { await updateLine(key, 0); }
    });
    cartBody.addEventListener('change', async (e) => {
      if (!e.target.matches('[data-line-input]')) return;
      const item = e.target.closest('[data-key]');
      await updateLine(item.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  // AJAX add-to-cart on product page
  const productForm = $('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('[data-add-to-cart]', productForm);
      const originalTxt = $('[data-atc-text]', btn).textContent;
      btn.disabled = true; $('[data-atc-text]', btn).textContent = 'Adding…';
      try {
        const fd = new FormData(productForm);
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!r.ok) throw new Error('Add to cart failed');
        await refreshCart();
        openDrawer(cartDrawer);
        $('[data-atc-text]', btn).textContent = 'Added ✓';
        setTimeout(() => { $('[data-atc-text]', btn).textContent = originalTxt; btn.disabled = false; }, 1400);
      } catch (err) {
        $('[data-atc-text]', btn).textContent = 'Try again';
        setTimeout(() => { $('[data-atc-text]', btn).textContent = originalTxt; btn.disabled = false; }, 1600);
      }
    });
  }

  /* ---------- Product page: variant selection, gallery, zoom ---------- */
  const productSection = $('[data-product-section]');
  if (productSection) {
    const variantSelect = $('[data-variant-select]', productSection);
    const optionInputs = $$('[data-option-input]', productSection);
    const priceEl = $('[data-price]', productSection);
    const atcTxt = $('[data-atc-text]', productSection);

    function currentValues() {
      const values = [];
      $$('.product__option', productSection).forEach((opt, idx) => {
        const checked = opt.querySelector('input[type="radio"]:checked');
        if (checked) values[idx] = checked.value;
        const label = $('[data-option-selected]', opt);
        if (label && checked) label.textContent = checked.value;
      });
      return values;
    }

    function updateVariant() {
      const values = currentValues();
      const opts = Array.from(variantSelect.options);
      const match = opts.find(o => {
        const parts = o.textContent.split(' / ').map(s => s.trim());
        return values.every((v, i) => parts[i] === v);
      });
      if (match) {
        variantSelect.value = match.value;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        history.replaceState({}, '', url);
        const price = parseInt(match.dataset.price, 10);
        const compare = parseInt(match.dataset.compare, 10) || 0;
        if (priceEl) {
          priceEl.innerHTML = `<span class="price ${compare > price ? 'price--on-sale' : ''}">
            ${compare > price ? `<span class="price__compare"><s>${money(compare)}</s></span>` : ''}
            <span class="price__current">${money(price)}</span></span>`;
        }
        if (atcTxt) atcTxt.textContent = match.disabled ? 'Sold out' : 'Add to bag';
        $('[data-add-to-cart]', productSection).disabled = match.disabled;
      }
      $$('.product__value', productSection).forEach(v => {
        const inp = v.querySelector('input');
        v.classList.toggle('is-selected', inp && inp.checked);
      });
    }

    optionInputs.forEach(inp => on(inp, 'change', updateVariant));

    // Gallery thumbs
    $$('[data-thumb-index]', productSection).forEach(thumb => {
      on(thumb, 'click', () => {
        const i = thumb.dataset.thumbIndex;
        $$('.product__thumb', productSection).forEach(t => { t.classList.toggle('is-active', t === thumb); t.setAttribute('aria-selected', t === thumb ? 'true' : 'false'); });
        $$('.product__media', productSection).forEach(m => m.classList.toggle('is-active', m.dataset.mediaIndex === i));
      });
    });

    // Zoom
    $$('[data-zoomable]', productSection).forEach(img => {
      on(img, 'click', () => img.classList.toggle('is-zoomed'));
    });
  }

  /* ---------- Predictive search ---------- */
  const searchDrawer = $('[data-search-drawer]');
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  on($('[data-open-search]'), 'click', () => { openDrawer(searchDrawer); setTimeout(() => searchInput?.focus(), 80); });
  $$('[data-close-search]').forEach(b => on(b, 'click', () => closeDrawer(searchDrawer)));

  let searchTimer;
  if (searchInput) {
    on(searchInput, 'input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6`);
          const data = await r.json();
          const products = (data.resources.results.products || []);
          const collections = (data.resources.results.collections || []);
          const articles = (data.resources.results.articles || []);
          if (!products.length && !collections.length && !articles.length) {
            searchResults.innerHTML = `<p style="color:var(--color-muted)">No results for "${q}"</p>`;
            return;
          }
          let html = '';
          if (collections.length) {
            html += `<div class="search-drawer__group"><h4>Collections</h4><ul style="list-style:none;padding:0;margin:0 0 24px;display:grid;gap:8px">`
              + collections.map(c => `<li><a href="${c.url}">${c.title}</a></li>`).join('')
              + `</ul></div>`;
          }
          if (products.length) {
            html += `<div class="search-drawer__group"><h4>Products</h4><div class="search-drawer__products">`
              + products.map(p => `
                <a href="${p.url}" class="product-card">
                  <div class="product-card__media">${p.featured_image?.url ? `<img src="${p.featured_image.url}" alt="${p.title}" loading="lazy" style="width:100%;height:100%;object-fit:cover">` : ''}</div>
                  <div class="product-card__body">
                    <h3 class="product-card__title">${p.title}</h3>
                    <div class="product-card__price">${p.price}</div>
                  </div>
                </a>
              `).join('') + `</div><div style="margin-top:20px"><a href="/search?q=${encodeURIComponent(q)}" class="btn btn--ghost">View all results</a></div></div>`;
          }
          if (articles.length) {
            html += `<div class="search-drawer__group" style="margin-top:24px"><h4>Journal</h4><ul style="list-style:none;padding:0;margin:0;display:grid;gap:8px">`
              + articles.map(a => `<li><a href="${a.url}">${a.title}</a></li>`).join('') + `</ul></div>`;
          }
          searchResults.innerHTML = html;
        } catch (err) { /* silent */ }
      }, 220);
    });
  }

  /* ---------- Newsletter popup ---------- */
  const popup = $('[data-newsletter-popup]');
  if (popup) {
    const KEY = 'lussera_np_dismissed';
    const delay = (parseInt(popup.dataset.delay, 10) || 8) * 1000;
    if (!localStorage.getItem(KEY)) {
      setTimeout(() => openDrawer(popup), delay);
    }
    $$('[data-close-np]', popup).forEach(b => on(b, 'click', () => { closeDrawer(popup); localStorage.setItem(KEY, '1'); }));
    popup.addEventListener('submit', () => localStorage.setItem(KEY, '1'), true);
  }

  /* ---------- Quick view (redirects to product for simplicity, adds a fast drawer look) ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.handle;
    try {
      const r = await fetch(`/products/${handle}.js`);
      const p = await r.json();
      const first = p.variants.find(v => v.available) || p.variants[0];
      cartBody.innerHTML = `
        <div style="padding:8px 0">
          <img src="${p.featured_image || (p.media && p.media[0] && p.media[0].src) || ''}" alt="${p.title}" style="width:100%;aspect-ratio:3/4;object-fit:cover;background:var(--color-surface);margin-bottom:16px">
          <h3 style="font-family:var(--font-heading);font-size:1.3rem;margin-bottom:6px">${p.title}</h3>
          <div style="margin-bottom:14px">${money(first.price)}</div>
          <p style="color:var(--color-muted);font-size:.9rem;margin-bottom:20px">${(p.description || '').replace(/<[^>]+>/g, '').slice(0, 220)}${(p.description || '').length > 220 ? '…' : ''}</p>
          <form data-quick-form>
            <input type="hidden" name="id" value="${first.id}">
            <button type="submit" class="btn btn--dark btn--full" ${!first.available ? 'disabled' : ''}>${first.available ? 'Add to bag' : 'Sold out'}</button>
          </form>
          <a href="/products/${p.handle}" style="display:block;text-align:center;margin-top:14px;text-decoration:underline;color:var(--color-muted);font-size:.85rem">View full details</a>
        </div>`;
      openDrawer(cartDrawer);
      const qf = cartBody.querySelector('[data-quick-form]');
      qf.addEventListener('submit', async (ev) => {
        ev.preventDefault();
        const fd = new FormData(qf);
        await fetch('/cart/add.js', { method: 'POST', body: fd });
        await refreshCart();
      });
    } catch (err) { window.location.href = `/products/${handle}`; }
  });

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  $$('[data-reveal], [data-reveal-children], .hero').forEach(el => io.observe(el));
  // Hero uses is-visible class for zoom-out effect
  requestAnimationFrame(() => $$('.hero').forEach(el => el.classList.add('is-visible')));

  /* ---------- ESC key closes drawers ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    [cartDrawer, searchDrawer, popup, mobileMenu].forEach(d => d && d.classList.contains('is-open') && closeDrawer(d));
  });

  /* ---------- Collection filters open/close ---------- */
  const filters = $('[data-filters]');
  if (filters) {
    on($('[data-open-filters]'), 'click', () => { filters.classList.add('is-open'); filters.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); });
    $$('[data-close-filters]', filters).forEach(b => on(b, 'click', () => { filters.classList.remove('is-open'); filters.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); }));
  }

  /* ---------- Collection sort by ---------- */
  const sortBy = $('[data-sort-by]');
  if (sortBy) {
    on(sortBy, 'change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortBy.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product qty ---------- */
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('.qty [data-qty-plus], .qty [data-qty-minus]');
    if (!qtyBtn) return;
    const wrap = qtyBtn.closest('.qty');
    const input = wrap.querySelector('input');
    if (!input) return;
    const val = parseInt(input.value, 10) || 1;
    input.value = qtyBtn.matches('[data-qty-plus]') ? val + 1 : Math.max(1, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Initial cart refresh (for count sync) ---------- */
  refreshCart().catch(() => {});
})();
